import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  FeeService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_UpdateSecFeeDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetSecFeeList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_UpdateSecFeeDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;

  const secFeeList = useQuery(
    ['getSecFeeList', filter, sorting, skipCount, maxResultCount],
    async () => {
      const data = await handleRequest(
        FeeService.getApiAwardApiAppFeeSecFeeList(filter, sorting, skipCount, maxResultCount)
      );

      const sortedItems = [...data?.items].sort(
        (a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime()
      );

      return {
        ...data,
        items: sortedItems,
      };
    }
  );
  return secFeeList;
};

export default useGetSecFeeList;
